import { render, staticRenderFns } from "./BasicControls.vue?vue&type=template&id=c1036c90&scoped=true&lang=html&"
import script from "./BasicControls.vue?vue&type=script&lang=js&"
export * from "./BasicControls.vue?vue&type=script&lang=js&"
import style0 from "./BasicControls.vue?vue&type=style&index=0&id=c1036c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1036c90",
  null
  
)

export default component.exports